import React from "react";

const About=()=>{
    return(

        <div className="container">
            <h1 className="topic my-4">About</h1>
            <h4 className="topic mx-2 my-2">CRUD Operation Create,Update,Delete,Insert...</h4>
        </div>
    );
}

export default About;